/**
 * RequireLite — `/app` is the Lite shell, and only Lite tenants belong in it.
 *
 * A Pro tenant landing here (a stale bookmark, a shared link, a tenant moved
 * back to Pro from the platform console) would get an eight-item nav over an
 * app that has 82 routes — most of their product silently missing, with no
 * error to explain it. Send them to the office shell instead.
 *
 * Renders children while the tenant doc is still resolving rather than
 * bouncing: `useTenant()` reports `tier` undefined for a beat on first paint,
 * and treating that as "not Lite" would flash a redirect to /home on every
 * cold load for the tenants this shell exists for. A Pro tenant reaching here
 * is the rare case; a Lite tenant reloading is the constant one.
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTenant } from '@/hooks/useTenant';

export function RequireLite({ children }: { children: ReactNode }) {
  const { tenant, isLoading } = useTenant();

  if (isLoading || !tenant) return <>{children}</>;
  if (tenant.tier !== 'lite') return <Navigate to="/home" replace />;
  return <>{children}</>;
}
